import axios from '../axios'
import qs from 'qs';

/* 
 * 权限管理模块
 */

// 保存
export const update = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/auth/update',
        method: 'post',
        data
    })
}
// 查询
export const list = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/auth/list',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/auth.js